var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMissed2 = function SvgMissed2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 1C14.187 1 18 4.813 18 9.5c0 4.687-3.813 8.5-8.5 8.5C4.813 18 1 14.187 1 9.5 1 4.813 4.813 1 9.5 1Zm0 1C5.364 2 2 5.364 2 9.5S5.364 17 9.5 17 17 13.636 17 9.5 13.636 2 9.5 2Zm.5 10v1H9v-1h1Zm0-6v5H9V6h1Z",
    fill: "#000"
  })));
};
export default SvgMissed2;